import script from "./privateKey.vue?vue&type=script&lang=ts&setup=true"
export * from "./privateKey.vue?vue&type=script&lang=ts&setup=true"

import "./privateKey.vue?vue&type=style&index=0&id=56a00a8a&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56a00a8a"]])

export default __exports__